/* eslint-disable i18next/no-literal-string --
 * React Query cache keys.
 */
/** Query keys for the `ad-format` slice. */
export const AD_FORMAT_QUERY_KEYS = {
  all: ['ad-formats'] as const,
  formatSpecs: () => [...AD_FORMAT_QUERY_KEYS.all, 'format-specs'] as const,
};
